import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import { authUser } from 'actions/users';

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.handlerAuth = this.handlerAuth.bind(this);
    }

    componentDidMount() {
        document.querySelector('.login-wrapper').classList.add('show');
    }

    componentDidUpdate() {
        const { isLogged, router } = this.props;
        if (isLogged) {
            router.push(this.getRedirectUrl());
        }
    }

    getRedirectUrl() {
        return this.props.router.location.query.backUrl || '/';
    }

    handlerAuth(e) {
        e.preventDefault();

        this.props.authUser(
            this.inputEmail.input.value,
            this.inputPassword.input.value,
        );
    }

    render() {
        return (
            <div id='login-page'>
                <div className='login-wrapper'>
                    <p className='login-title'>SHIPNEXT ADMIN PANEL</p>
                    <form onSubmit={this.handlerAuth}>
                        <TextField
                            ref={(inputEmail) => {
                                this.inputEmail = inputEmail;
                            }}
                            hintText='EMAIL'
                            type='email'
                            name='email'
                            required
                        />

                        <br />

                        <TextField
                            ref={(inputPassword) => {
                                this.inputPassword = inputPassword;
                            }}
                            hintText='PASSWORD'
                            type='password'
                            name='password'
                            required
                        />

                        <br />

                        <div className={this.props.errorMessage ? 'error' : 'hidden'}>
                            { this.props.errorMessage }
                        </div>

                        <RaisedButton onSubmit={this.handlerAuth} label='login' type='submit' />
                    </form>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        isLogged: state.user.isLogged,
        errorMessage: state.user.message,
    }),
    dispatch => bindActionCreators({
        authUser,
    },
    dispatch),
)(Login);



// WEBPACK FOOTER //
// ./app/components/Pages/Login.jsx